module.exports = __webpack_public_path__ + "static/img/tutorial-tool-competitiveness-3.f56b016.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tutorial-tool-competitiveness-3.jpg
// module id = J2nI
// module chunks = 3